import { render } from "./preventivoList.vue?vue&type=template&id=0961dc74"
import script from "./preventivoList.vue?vue&type=script&lang=js"
export * from "./preventivoList.vue?vue&type=script&lang=js"

import "./preventivoList.vue?vue&type=style&index=0&id=0961dc74&lang=css"

import exportComponent from "D:\\sistema_regimen_penitenciario\\sirep_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__